import { render, staticRenderFns } from "./customConfig.vue?vue&type=template&id=3f23da27&scoped=true"
import script from "./customConfig.vue?vue&type=script&lang=js"
export * from "./customConfig.vue?vue&type=script&lang=js"
import style0 from "./customConfig.vue?vue&type=style&index=0&id=3f23da27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f23da27",
  null
  
)

export default component.exports